import * as ActionTypes from "./careerActionType";

const initialState = {
    isLoading: false,
    jobs: [],
    currentJob: null,
    application: null,
    trackedApplication: null,
    isApplicationSubmitted: false
};

export const careerReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GET_JOBS:
            return {
                ...state,
                isLoading: true,
            }
        case ActionTypes.GET_JOBS_FAILURE:
            return {
                ...state,
                isLoading: false,
            }
        case ActionTypes.GET_JOBS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                jobs: action?.payload?.data || []
            }
        case ActionTypes.GET_JOB:
            return {
                ...state,
                isLoading: true,
                currentJob: null
            }
        case ActionTypes.GET_JOB_FAILURE:
            return {
                ...state,
                isLoading: false,
            }
        case ActionTypes.GET_JOB_SUCCESS:
            return {
                ...state,
                isLoading: false,
                currentJob: action?.payload?.data || null
            }
        case ActionTypes.CREATE_APPLICATION:
            return {
                ...state,
                isLoading: true,
                isApplicationSubmitted: false
            }
        case ActionTypes.CREATE_APPLICATION_FAILURE:
            return {
                ...state,
                isLoading: false,
                isApplicationSubmitted: false
            }
        case ActionTypes.CREATE_APPLICATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isApplicationSubmitted: true,
                application: action?.payload?.data || null
            }
        case ActionTypes.TRACK_APPLICATION:
            return {
                ...state,
                isLoading: true,
                trackedApplication: null
            }
        case ActionTypes.TRACK_APPLICATION_FAILURE:
            return {
                ...state,
                isLoading: false,
            }
        case ActionTypes.TRACK_APPLICATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                trackedApplication: action?.payload?.data || null
            }
        default:
            return state
    }
}

